import { c as e } from "react/compiler-runtime";
import { createContext as t, useContext as n } from "react";
import { jsx as r } from "react/jsx-runtime";
//#region src/router-context.ts
var i = t(null);
function a() {
	let e = n(i);
	if (!e) throw Error("`compatibility-router` hooks and components must be used inside <RouterProvider>");
	return e;
}
//#endregion
//#region src/link.tsx
function o(e) {
	return e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
}
function s(t) {
	let n = e(26), i, s, c, l, u, d, f;
	n[0] === t ? (i = n[1], s = n[2], c = n[3], l = n[4], u = n[5], d = n[6], f = n[7]) : ({to: f, params: c, search: u, onClick: s, target: d, children: i, ...l} = t, n[0] = t, n[1] = i, n[2] = s, n[3] = c, n[4] = l, n[5] = u, n[6] = d, n[7] = f);
	let { buildHref: p, navigate: m } = a(), h;
	n[8] !== p || n[9] !== c || n[10] !== u || n[11] !== f ? (h = p({
		to: f,
		params: c,
		search: u
	}), n[8] = p, n[9] = c, n[10] = u, n[11] = f, n[12] = h) : h = n[12];
	let g = h, _;
	n[13] !== m || n[14] !== s || n[15] !== c || n[16] !== u || n[17] !== d || n[18] !== f ? (_ = function(e) {
		s?.(e), !e.defaultPrevented && e.button === 0 && (o(e) || d && d !== "_self" || (e.preventDefault(), m({
			to: f,
			params: c,
			search: u
		})));
	}, n[13] = m, n[14] = s, n[15] = c, n[16] = u, n[17] = d, n[18] = f, n[19] = _) : _ = n[19];
	let v = _, y;
	return n[20] !== i || n[21] !== v || n[22] !== g || n[23] !== l || n[24] !== d ? (y = /* @__PURE__ */ r("a", {
		...l,
		href: g,
		onClick: v,
		target: d,
		children: i
	}), n[20] = i, n[21] = v, n[22] = g, n[23] = l, n[24] = d, n[25] = y) : y = n[25], y;
}
//#endregion
//#region src/router-provider.tsx
function c(t) {
	let n = e(6), { children: a, navigate: o, buildHref: s } = t, c;
	n[0] !== s || n[1] !== o ? (c = {
		navigate: o,
		buildHref: s
	}, n[0] = s, n[1] = o, n[2] = c) : c = n[2];
	let l;
	return n[3] !== a || n[4] !== c ? (l = /* @__PURE__ */ r(i, {
		value: c,
		children: a
	}), n[3] = a, n[4] = c, n[5] = l) : l = n[5], l;
}
//#endregion
//#region src/use-navigate.ts
function l() {
	let t = e(2), { navigate: n } = a(), r;
	return t[0] === n ? r = t[1] : (r = function(e) {
		let { to: t, params: r, search: i, replace: a } = e;
		n({
			to: t,
			params: r,
			search: i,
			replace: a
		});
	}, t[0] = n, t[1] = r), r;
}
//#endregion
export { s as Link, c as RouterProvider, l as useNavigate };
